import axios from "axios";

type IdType = "email" | "id";
export const fetchCustomerByEmail = async (email: string, id_type: "email" | "id") => {
  const url = `${process.env.NEXT_PUBLIC_CUSTOMER_IO_URL}customers/${email}/attributes?id_type=${id_type}`;
  const response = await axios.get(encodeURI(url), {
    headers: {
      Authorization: `Bearer ${process.env.CUSTOMER_IO_API_KEY}`,
    },
  });
  return response.data;
};

export const getCustomerByEmail = async (email: string, idTypes: IdType[] = ["id", "email"]) => {
  const idType = idTypes.pop();
  // Checking on length doesn't let typescript
  // now that idType is guaranteed to be defined
  if (idType !== undefined) {
    try {
      return await fetchCustomerByEmail(email, idType);
    } catch (e) {
      switch (e.response.status) {
        case 404:
          return null;
        case 400:
          console.error(`The id_type ${idType} is not valid for the current customerio workspace`);
          return await getCustomerByEmail(email, idTypes);
        default:
          throw e;
      }
    }
  } else {
    throw new Error("No id type comptabile with the selected workspace");
  }
};

export const customerIoSubscription = async (
  identifyData: CIO.CustomerAttributes,
  subscribeData: CIO.SubscribeData | null
) => {
  return await axios.post("/next-api/customer-io-subscription", {
    identifyData: identifyData,
    subscribeData: subscribeData,
  });
};
